import { Controller } from "@hotwired/stimulus"

// Reloads the page every so often while something finishes on the server (a
// note being recorded or its video rendering, video_notes/show_twin) - but
// never while you're recording your own voice on it (shared/_voice_recorder),
// which a <meta refresh> would cut off mid-take. The server stops rendering
// this once there's nothing left to wait for.
export default class extends Controller {
  static values = { every: { type: Number, default: 15000 } }

  connect() {
    this._timer = setInterval(() => {
      if (document.visibilityState !== "visible") return
      if (document.querySelector(".voice-recorder .is-recording, .voice-recorder [data-voice-recorder-target=record]:disabled")) return
      window.location.reload()
    }, this.everyValue)
  }

  disconnect() {
    clearInterval(this._timer)
  }
}
